import { type FormEvent, useState } from 'react';

import { KeyRound, MapPinned, ShieldCheck } from 'lucide-react';

interface LoginScreenProps {
  loading: boolean;
  submitting: boolean;
  error: string | null;
  onLogin: (password: string) => Promise<boolean>;
  onRetry: () => Promise<void>;
}

export function LoginScreen({
  loading,
  submitting,
  error,
  onLogin,
  onRetry,
}: LoginScreenProps): React.JSX.Element {
  const [password, setPassword] = useState('');

  const submit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
    if (!password || submitting) {
      return;
    }
    if (await onLogin(password)) {
      setPassword('');
    }
  };

  return (
    <main className="login-page">
      <section className="login-card" aria-labelledby="login-title">
        <div className="login-brand" aria-hidden="true">
          <MapPinned size={31} />
        </div>
        <span className="eyebrow">Privater Kartenstand</span>
        <h1 id="login-title">SatisMap öffnen</h1>
        <p>
          Der Zugriff ist geschützt. Das Passwort wird ausschließlich an das
          Backend übertragen und nicht im Browser gespeichert.
        </p>

        <form onSubmit={(event) => void submit(event)}>
          <label htmlFor="satismap-password">Passwort</label>
          <div className="login-password-field">
            <KeyRound size={19} aria-hidden="true" />
            <input
              id="satismap-password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              autoFocus
              maxLength={256}
              disabled={loading || submitting}
              placeholder="Passwort eingeben"
            />
          </div>
          {error ? <div className="login-error" role="alert">{error}</div> : null}
          <button
            className="login-submit"
            type="submit"
            disabled={loading || submitting || !password}
          >
            <ShieldCheck size={18} aria-hidden="true" />
            {loading ? 'Verbindung wird geprüft …' : submitting ? 'Anmeldung läuft …' : 'Karte öffnen'}
          </button>
        </form>
        {error && loading ? (
          <button className="text-button login-retry" type="button" onClick={() => void onRetry()}>
            Erneut verbinden
          </button>
        ) : null}
      </section>
    </main>
  );
}
